import { render, staticRenderFns } from "./EnrollDetails.vue?vue&type=template&id=e5326f02&"
import script from "./EnrollDetails.vue?vue&type=script&lang=js&"
export * from "./EnrollDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports